// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper___bw0n","title":"ClientCherryInfo_title__1C-O2","itemText":"ClientCherryInfo_itemText__1muGy"};